export const footerMoreLinks = {
  'ca-en': [
    {
      title: 'More',
      items: [
        { title: 'Contact', href: 'https://ca.wingie.com/contact/' },
        {
          title: 'Frequently Asked Questions',
          href: 'https://ca.wingie.com/faq/',
        },

        { title: 'About us', href: 'https://ca.wingie.com/about-us/' },
        { title: 'Privacy', href: 'https://ca.wingie.com/privacy/' },
        {
          title: 'Terms and Conditions',
          href: 'https://ca.wingie.com/terms-and-conditions/',
        },
        {
          title: 'Awards',
          href: 'https://ca.wingie.com/awards/',
        },
      ],
    },
  ],
  'ca-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://ca.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://ca.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://ca.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://ca.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://ca.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          title: 'Nuestros premios',
          href: 'https://ca.wingie.com/es/awards/',
        },
      ],
    },
  ],
  'ca-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://ca.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://ca.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },

        {
          href: 'https://ca.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://ca.wingie.com/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://ca.wingie.com/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          title: 'جوائزنا',
          href: 'https://ca.wingie.com/ar/awards/',
        },
      ],
    },
  ],
  'ca-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://ca.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://ca.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://ca.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://ca.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://ca.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          title: 'Наши награды',
          href: 'https://ca.wingie.com/ru/awards/',
        },
      ],
    },
  ],
  'ca-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://ca.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://ca.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://ca.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://ca.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://ca.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          title: 'Unsere Auszeichnungen',
          href: 'https://ca.wingie.com/de/awards/',
        },
      ],
    },
  ],
  'ca-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://ca.wingie.com/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://ca.wingie.com/it/faq/' },

        { title: 'Chi siamo', href: 'https://ca.wingie.com/it/about-us/' },
        { title: 'Privacy', href: 'https://ca.wingie.com/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://ca.wingie.com/it/terms-and-conditions/' },
        {
          title: 'I nostri premi',
          href: 'https://ca.wingie.com/it/awards/',
        },
      ],
    },
  ],
  'ca-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://ca.wingie.com/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://ca.wingie.com/fr/faq/' },

        { title: 'À propos de nous', href: 'https://ca.wingie.com/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://ca.wingie.com/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://ca.wingie.com/fr/terms-and-conditions/' },
        {
          title: 'Nos prix',
          href: 'https://ca.wingie.com/fr/awards/',
        },
      ],
    },
  ],
  'ca-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contato', href: 'https://ca.wingie.com/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://ca.wingie.com/pt/faq/' },

        { title: 'Sobre nós', href: 'https://ca.wingie.com/pt/about-us/' },
        { title: 'Privacidade', href: 'https://ca.wingie.com/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://ca.wingie.com/pt/terms-and-conditions/' },
        {
          title: 'Nossos prêmios',
          href: 'https://ca.wingie.com/pt/awards/',
        },
      ],
    },
  ],
  'ca-ro': [
    {
      title: 'Mai multe',
      items: [
        { title: 'Contact', href: 'https://ca.wingie.com/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://ca.wingie.com/ro/faq/' },

        { title: 'Despre noi', href: 'https://ca.wingie.com/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://ca.wingie.com/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://ca.wingie.com/ro/terms-and-conditions/' },
        {
          title: 'Premii noastre',
          href: 'https://ca.wingie.com/ro/awards/',
        },
      ],
    },
  ],
  'ca-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://ca.wingie.com/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://ca.wingie.com/pl/faq/' },

        { title: 'O nas', href: 'https://ca.wingie.com/pl/about-us/' },
        { title: 'Prywatność', href: 'https://ca.wingie.com/pl/privacy/' },
        { title: 'Regulamin', href: 'https://ca.wingie.com/pl/terms-and-conditions/' },
        {
          title: 'Nasze nagrody',
          href: 'https://ca.wingie.com/pl/awards/',
        },
      ],
    },
  ],
  'ca-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://ca.wingie.com/lt/contact/' },
        // { title: 'Dažniausiai užduodami klausimai', href: 'https://ca.wingie.com/lt/faq/' },

        { title: 'Apie mus', href: 'https://ca.wingie.com/lt/about-us/' },
        { title: 'Privatumas', href: 'https://ca.wingie.com/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://ca.wingie.com/lt/terms-and-conditions/' },
        {
          title: 'Mūsų premijos',
          href: 'https://ca.wingie.com/lt/awards/',
        },
      ],
    },
  ],
  'ca-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://ca.wingie.com/uz/contact/' },
        // { title: "Tez-tez so'raladigan savollar", href: 'https://ca.wingie.com/uz/faq/' },

        { title: 'Biz haqimizda', href: 'https://ca.wingie.com/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://ca.wingie.com/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://ca.wingie.com/uz/terms-and-conditions/' },
        {
          title: 'Bizning mukofotlarimiz',
          href: 'https://ca.wingie.com/uz/awards/',
        },
      ],
    },
  ],
  'ca-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://ca.wingie.com/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://ca.wingie.com/sr/faq/' },

        { title: 'O nama', href: 'https://ca.wingie.com/sr/about-us/' },
        { title: 'Privatnost', href: 'https://ca.wingie.com/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://ca.wingie.com/sr/terms-and-conditions/' },
        {
          title: 'Naše nagrade',
          href: 'https://ca.wingie.com/sr/awards/',
        },
      ],
    },
  ],
  'ca-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://ca.wingie.com/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://ca.wingie.com/ky/faq/' },

        { title: 'Біз жөнүндө', href: 'https://ca.wingie.com/ky/about-us/' },
        { title: 'Жашыруундук', href: 'https://ca.wingie.com/ky/privacy/' },
        { title: 'Шарттар жана эрежелер', href: 'https://ca.wingie.com/ky/terms-and-conditions/' },
        {
          title: 'Біздің марапаттарымыз',
          href: 'https://ca.wingie.com/ky/awards/',
        },
      ],
    },
  ],
  'ca-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Тамос', href: 'https://ca.wingie.com/tg/contact/' },
        // { title: 'Саволҳои зиёд пурсидашаванда', href: 'https://ca.wingie.com/tg/faq/' },

        { title: 'Дар бораи мо', href: 'https://ca.wingie.com/tg/about-us/' },
        { title: 'Махфият', href: 'https://ca.wingie.com/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://ca.wingie.com/tg/terms-and-conditions/' },
        {
          title: 'Біздің марапаттарымыз',
          href: 'https://ca.wingie.com/tg/awards/',
        },
      ],
    },
  ],
  'ca-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://ca.wingie.com/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://ca.wingie.com/kk/faq/' },

        { title: 'Біз туралы', href: 'https://ca.wingie.com/kk/about-us/' },
        { title: 'Құпиялық', href: 'https://ca.wingie.com/kk/privacy/' },
        { title: 'Шарттар мен ережелер', href: 'https://ca.wingie.com/kk/terms-and-conditions/' },
        {
          title: 'Біздің марапаттарымыз',
          href: 'https://ca.wingie.com/kk/awards/',
        },
      ],
    },
  ],
  'ca-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://ca.wingie.com/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://ca.wingie.com/nl/faq/' },

        { title: 'Over ons', href: 'https://ca.wingie.com/nl/about-us/' },
        { title: 'Privacy', href: 'https://ca.wingie.com/nl/privacy/' },
        { title: 'Voorwaarden', href: 'https://ca.wingie.com/nl/terms-and-conditions/' },
        {
          title: 'Onze prijzen',
          href: 'https://ca.wingie.com/nl/awards/',
        },
      ],
    },
  ],
  'ca-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://ca.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://ca.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://ca.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://ca.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://ca.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://ca.wingie.com/ja/awards/' },
      ],
    },
  ],
  'ca-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://ca.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://ca.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://ca.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://ca.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://ca.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://ca.wingie.com/zh/awards/' },
      ],
    },
  ],
  'ca-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://ca.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://ca.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://ca.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://ca.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://ca.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://ca.wingie.com/ko/awards/' },
      ],
    },
  ],
  'ca-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://ca.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://ca.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://ca.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://ca.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://ca.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://ca.wingie.com/hi/awards/' },
      ],
    },
  ],
  'ca-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://ca.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://ca.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://ca.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://ca.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://ca.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://ca.wingie.com/ta/awards/' },
      ],
    },
  ],
  'ca-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://ca.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://ca.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://ca.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://ca.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://ca.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://ca.wingie.com/th/awards/' },
      ],
    },
  ],
  'ca-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://ca.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://ca.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://ca.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://ca.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://ca.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://ca.wingie.com/ur/awards/' },
      ],
    },
  ],
  'ca-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://ca.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://ca.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://ca.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://ca.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://ca.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://ca.wingie.com/ka/awards/' },
      ],
    },
  ],
}
